import { defineComponent, onMounted } from "vue";
import DeleteBtn from "./delete-btn/index.vue";
import { BizFileService } from "@/core";
import { FilePageReq } from "@/core/services/biz-file.interface";
import { columns } from "./biz-file-table.constant";
import mixins from "@/core/mixins/table-height.mixins";
import { saveAs } from "file-saver";
export default defineComponent({
  global: true,
  name: "BizFileTable",
  components: { DeleteBtn },
  props: {
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    allowEdit: {
      type: Boolean,
      default: false,
    },
    downloadAccess: {
      type: String,
    },
    deleteAccess: {
      type: String,
    },
  },
  setup(props) {
    const fileReq = new FilePageReq();
    fileReq.merge({
      bizId: props.bizId,
      bizType: props.bizType,
    });
    const { data: fileList, loading, run, refresh, pagination } = BizFileService.usePageApi();

    const reload = async () => {
      fileReq.current = 1;
      await run(fileReq);
    };

    const onTableChange = async (pagination) => {
      fileReq.current = pagination.current;
      fileReq.size = pagination.pageSize;
      await run(fileReq);
    };
    const { setTableHeight, tableHeight } = mixins();
    onMounted(async () => {
      await run(fileReq);
      setTableHeight(30);
    });
    const downloadFile = (record) => {
      // // console.log(record.url,record.name)
      saveAs(record.url, record.name);
    };
    return {
      columns,
      fileList,
      loading,
      pagination,
      refresh,
      reload,
      onTableChange,
      tableHeight,
      downloadFile,
    };
  },
});
